import { render, staticRenderFns } from "./warning-set.vue?vue&type=template&id=008e1252"
import script from "./warning-set.vue?vue&type=script&lang=js"
export * from "./warning-set.vue?vue&type=script&lang=js"
import style0 from "./warning-set.vue?vue&type=style&index=0&id=008e1252&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports